import { Card } from "@/components/ui/card";
import type { Block } from "@/types/proposals";

interface TotalsBlockProps {
  block: Block;
  onUpdate: (updates: Partial<Block>) => void;
  onSelect: () => void;
}

export function TotalsBlock({ block, onUpdate, onSelect }: TotalsBlockProps) {
  const { subtotal = 0, tax = 0, discount = 0, total = 0 } = block.content;

  return (
    <div className="cursor-pointer hover:ring-2 hover:ring-primary/50 transition-all rounded p-6" onClick={onSelect}>
      <Card className="p-6 max-w-md ml-auto">
        <div className="space-y-3">
          <div className="flex justify-between">
            <span>Subtotal:</span>
            <span>${subtotal.toFixed(2)}</span>
          </div>
          {discount > 0 && (
            <div className="flex justify-between text-green-600">
              <span>Discount:</span>
              <span>-${discount.toFixed(2)}</span>
            </div>
          )}
          {tax > 0 && (
            <div className="flex justify-between">
              <span>Tax:</span>
              <span>${tax.toFixed(2)}</span>
            </div>
          )}
          <div className="border-t pt-3 flex justify-between text-xl font-bold">
            <span>Total:</span>
            <span className="text-primary">${total.toFixed(2)}</span>
          </div>
        </div>
      </Card>
    </div>
  );
}
